<span>EZLynx Five [{{server || '00'}}] ({{user?.userName}})</span>
@if (user?.supportPersonId) {
  <span>Impersonator: {{user.supportPersonUserName}}</span>
}
<span>{{copyright}}</span>